import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

/**
 * CourseOutline resource with icon and description beneath.
 * https://academicmerit.atlassian.net/browse/FY-18385
 * */
const ResourceWithDescription = ({ icon, title, description }) => (
  <div className="co-resource-with-description-container">
    <div className="co-resource-icon">{icon}</div>
    <div className="co-resource-data">
      <div className="co-resource-title">{title}</div>
      <div className="co-resource-description">{description}</div>
    </div>
  </div>
);

ResourceWithDescription.displayName = 'ResourceWithDescription';

ResourceWithDescription.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
};

export default ResourceWithDescription;
